import { render, staticRenderFns } from "./SubmissionDateIcon.vue?vue&type=template&id=efd6d410"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd6d410')) {
      api.createRecord('efd6d410', component.options)
    } else {
      api.reload('efd6d410', component.options)
    }
    module.hot.accept("./SubmissionDateIcon.vue?vue&type=template&id=efd6d410", function () {
      api.rerender('efd6d410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SubmissionDateIcon.vue"
export default component.exports